import React from "react";

// Follow-up suggestion chips rendered at the bottom of an assistant message (B-UX-FOLLOWUP-1).
// Clicking a chip submits its text as the next user message.
//
// Props:
//   suggestions : string[]
//   onSelect    : (text) => void

export default function FollowUpChips({ suggestions, onSelect }) {
  if (!suggestions || suggestions.length === 0) return null;
  return (
    <div className="mt-3 flex flex-wrap gap-2">
      {suggestions.map((s, i) => (
        <button
          key={i}
          type="button"
          onClick={() => onSelect && onSelect(s)}
          className="text-xs px-3 py-1 rounded-full border border-gray-300 text-gray-700 hover:border-gray-400 hover:bg-gray-50 transition-colors"
        >
          {s}
        </button>
      ))}
    </div>
  );
}
